import { useTranslation } from 'react-i18next';
import SearchableSelect from '../searchableSelect/searchableSelect';
import { useMatterRequestHomeCountrySelect } from './useMatterRequestHomeCountrySelect';

interface MatterRequestHomeCountrySelectProps {
  onOpenPicker: () => void;
}

/**
 * Its own component so the country list is only fetched where the field is rendered. It renders
 * the trigger button directly, which lookup siblings like `LookupClearButton` rely on.
 */
const MatterRequestHomeCountrySelect = ({
  onOpenPicker,
}: Readonly<MatterRequestHomeCountrySelectProps>) => {
  const { t } = useTranslation();
  const select = useMatterRequestHomeCountrySelect();

  return (
    <SearchableSelect
      {...select}
      ariaLabel={t('common:homeCountry')}
      placeholder={t('customer:selectHomeCountry')}
      searchPlaceholder={t('customer:searchHomeCountries')}
      onSearchIconClick={onOpenPicker}
      data-field="homeCountry"
      data-testid="select-home-country-button"
    />
  );
};

export default MatterRequestHomeCountrySelect;
